import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getClientes } from "../../redux/actions/actionClient";
import ClientsCard from "./clientsCard";
import LoadingIcons from "react-loading-icons";

export default function Clients(){
    const clients = useSelector((state)=> state.clientes.allClientes)
    const dispatch = useDispatch();
    const [clientFind, setClientFind] = useState();
    const [clientInput, setClientInput] = useState("");

    useEffect(() => {
        dispatch(getClientes())
    }, [dispatch])

    const handleChange = (e) => {
      const { value } = e.target
      setClientInput(value)
    }

    const filterClient = () => {
       console.log(clientInput);
        if (clientFind === undefined) {
          let result = clients.filter((e) => {
            if (
              e.name
                .toString()
                .toLowerCase()
                .includes(clientInput.toLowerCase())
                || e.lastName
                .toString()
                .toLowerCase()
                .includes(clientInput.toLowerCase())
                || e.nameCompany
                .toString()
                .toLowerCase()
                .includes(clientInput.toLowerCase())
                 ) {
              //console.log(e)
              return e;
            }
          });
          setClientFind(result);
        } else {
          let result = clientFind.filter((e) => {
            if (
              e.name
                .toString()
                .toLowerCase()
                .includes(clientInput.toLowerCase())
                || e.lastName
                .toString()
                .toLowerCase()
                .includes(clientInput.toLowerCase())
                || e.nameCompany
                .toString()
                .toLowerCase()
                .includes(clientInput.toLowerCase())
              ) {
                //console.log(e)
                return e;
              }
            });
            setClientFind(result);
          }
        };

        const handleLimpiar = () => {
          console.log(clientFind);
          setClientFind(clients)
        }
       
    
    console.log(clients)
    //console.log(clients[1])

    return (
        <div className="container bg-gray-900">
            <div className="">
            <div>
                <p className="text-[20pt] h-10 ml-2 mt-4 pb-8 underline text-orange-500">
                    Informes - Clientes
                </p>
            </div>
            <div className="h-24 pl-2 pt-2 mt-4 bg-cyan-900  ">
            <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="text"
              placeholder="Nombre Cliente"
              onChange={handleChange}
              
            />
          </div>
          <div className="w-56 text-center">
            <button className="w-16 ml-14 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={filterClient}>Buscar</button>
            <button className="w-16 h-6 ml-2 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={handleLimpiar}>Limpiar</button>
          </div>
            </div>
            <div className="flex flex-row text-[14px] font-bold   text-orange-500">
                    <div className="text-center w-12">N° Cliente</div>
                    <div className="pl-3 w-[263px]">Empresa</div>
                    <div className="w-32">Apellido</div>
                    <div className="w-32">Nombre</div>
                    <div className="w-40">Domicilio</div>
                    <div className="w-32">Ciudad</div>
                    <div className="w-48">Telefonos</div>
                    {/* <div>Contacto</div>
                    <div>Email</div>
                    <div>Notas</div> */}
                </div>

                <div className="container max-h-screen overflow-y-auto">
                  { clients.length === 0 ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> :
                clientFind === undefined ?
                clients.map(e => {
                    return (
                        <div key={e._id}>                            
                    <ClientsCard 
                        key={e._id}
                        _id={e._id}
                        id={e.idClient}
                        codeInt={e.codeInt}
                        name={e.name}
                        lastName={e.lastName}
                        nameCompany={e.nameCompany}
                        address={e.address}
                        city={e.city}
                        telephoneNumber={e.telephoneNumber}
                        // contactName={e.contactName}
                        // email={e.email}
                        // notes={e.notes}
                    />
                    </div>
                    )
                    })
            :   
            clientFind.map(e => {
                return (
                    <div key={e._id}>
                <ClientsCard 
                    key={e._id}
                    _id={e._id}
                    id={e.idClient}
                    codeInt={e.codeInt}
                    name={e.name}
                    lastName={e.lastName}
                    nameCompany={e.nameCompany}
                    address={e.address}
                    city={e.city}
                    telephoneNumber={e.telephoneNumber}
                    // contactName={e.contactName}
                    // email={e.email}
                    // notes={e.notes}
                />
                </div>
                )
                })            
            }
            
              </div>
            </div>
        </div>
    )
}